<template>
  <TextField
    ref="field"
    :model-value="modelValue"
    :label="label"
    :name="name"
    :hint="hint"
    :help="help"
    :error="error"
    :server-error="serverError"
    :placeholder="placeholder"
    :disabled="disabled"
    autocomplete="off"
    @update:model-value="onUpdate"
    @blurred="onBlur"
  />
</template>

<script setup lang="ts">
import { useTemplateRef } from 'vue'

import TextField from './TextField.molecule.vue'

withDefaults(
  defineProps<{
    /** Controlled recovery-code value as a plain string. */
    modelValue?: string
    /** Visible label text, already translated. */
    label?: string
    /** HTML form field name. */
    name?: string
    /** Supplementary explanation revealed by an info icon after the label. */
    hint?: string
    /** Instructions shown under the control; they stay visible while an error shows. */
    help?: string
    /** Resolved client-side message. */
    error?: string
    /** Submit-only failure; wins over `error` as the newer verdict. */
    serverError?: string
    /** Format example shown in the empty field. */
    placeholder?: string
    /** Whether user interaction with the field is disabled. */
    disabled?: boolean
  }>(),
  {
    disabled: false,
    error: '',
    help: '',
    hint: '',
    label: '',
    modelValue: '',
    name: 'recovery_code',
    placeholder: '',
    serverError: ''
  }
)

const emit = defineEmits<{
  'update:modelValue': [value: string]
  blurred: []
}>()

const onBlur = (): void => {
  emit('blurred')
}

const onUpdate = (value: string): void => {
  emit('update:modelValue', value.replace(/[^a-zA-Z0-9-]/gu, ''))
}

const field = useTemplateRef<{ focus?: () => void }>('field')

defineExpose({
  focus: () => field.value?.focus?.()
})
</script>
